/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Modal, Input, Button, message, Radio, Select } from 'antd'
import { getCNLocation } from '../../../util/location'
import TMap from 'TMap'
import {
  getDeviceLocation,
  getGeocoderlocation,
  getLocationForAddress,
} from '../../../api/clubInfo'
import InputGroup from './inputGroup'
import './style.css'
import MarkerImg from '../../../assert/images/map_marker_center_img.png'

const { Option } = Select

let map = null
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      account: '',
      password: '',
      official_person: '',
      contact_number: '',
      official_person_phone: '',
      club_address: '',
      longitude: '',
      latitude: '',
      code: '0000',
      isFinish: false,
      poiList: [], // poi 地址数组
      selectPoi: '',
      locationArr: [],
      province: '',
      city: '',
      area: '',
      provinceIndex: 0,
      cityIndex: 0,
    }
  }

  componentWillUnmount() {
    if (map) {
      map.off('dragend', this.handleMapDragEnd)
    }
  }

  componentDidMount() {
    const { locationMessage, record } = this.props
    const { province, city, area, club_address } = record
    this.setState(
      {
        name: record.club_name,
        account: record.account,
        official_person: record.official_person,
        contact_number: record.contact_number,
        official_person_phone: record.official_person_phone,
        province,
        city,
        area,
        // club_address: `${province}${city}${area}${club_address}`,
        club_address,
        code: locationMessage.code,
        latitude: +locationMessage.latitude,
        longitude: +locationMessage.longitude,
        locationArr: getCNLocation(),
      },
      () => {
        const { locationArr } = this.state
        if (province) {
          locationArr.map((item, index) => {
            if (item.name == province) {
              this.setState(
                {
                  provinceIndex: index,
                },
                () => {
                  if (city) {
                    locationArr[index].children.map(($item, $index) => {
                      if ($item.name == city) {
                        this.setState({
                          cityIndex: $index,
                        })
                      }
                    })
                  }
                }
              )
            }
          })
        }
      }
    )
    if (locationMessage) {
      const { latitude, longitude } = locationMessage
      setTimeout(() => {
        this.initQQMap({ lat: latitude, lng: longitude })
      }, 500)
    } else {
      this.ipLocation()
    }
  }

  initQQMap = (location = null) => {
    map = new TMap.Map(document.getElementById('mQmap'), {
      zoom: 21,
      mapStyleId: 'style1' //个性化地图样式设置
    })

    let center = null
    if (location) {
      center = new TMap.LatLng(location.lat, location.lng)
    } else {
      center = map.getCenter()
    }
    this.mapSetCenter(center)
    this.setState({
      isFinish: true,
    })
    map.on('dragend', this.handleMapDragEnd)
  }

  // GL JS exposes events on map instances; the legacy TMap.event API is unavailable.
  handleMapDragEnd = () => {
    this.locationForAddress()
  }

  mapSetCenter = (LatLng) => {
    map.setCenter(LatLng)
    map.zoomTo(21)
  }

  // 根据本地定位信息
  ipLocation = () => {
    getDeviceLocation()
      .then((res) => {
        if (res.status == 0) {
          const { ad_info } = res.result
          this.setState({ code: ad_info.adcode })
          this.initQQMap(res.result.location)
        } else {
          this.initQQMap()
        }
      })
      .catch((e) => {
        this.initQQMap()
      })
  }

  addressLocation = (address = '') => {
    if (!address || address == '' || address.length == 0) {
      return
    }
    getGeocoderlocation(address)
      .then((res) => {
        if (res.status == 0) {
          const { location, ad_info } = res.result
          // 如果他手动搜索出来不点击 地图检索出来的地址 这样也需要赋值经纬度一次
          this.setState({
            latitude: location.lat,
            longitude: location.lng,
            code: ad_info.adcode,
          })
          const center = new TMap.LatLng(location.lat, location.lng)
          this.mapSetCenter(center)
          this.locationForAddress()
          return
        }
        message.info(res.message + '，需要输入市级搜索')
      })
      .catch((e) => {
        message.error('定位失败，请重试!')
      })
  }

  locationForAddress = () => {
    const center = map.getCenter()
    this.setState({
      longitude: center.lng,
      latitude: center.lat,
    })
    getLocationForAddress(center.lat, center.lng)
      .then((res) => {
        const { status, result } = res
        if (status == 0) {
          const { pois } = result
          this.setState({
            poiList: pois.slice(0, 10),
            selectPoi: '',
          })
        }
      })
      .catch((e) => {
        console.log('失败', e)
      })
  }

  // 地址选择
  poiRadioEvent = (e) => {
    const value = e.target.value
    const sItem = this.state.poiList.find((item) => item.id == value)
    const { location, ad_info } = sItem
    const { lat, lng } = location
    const center = new TMap.LatLng(lat, lng)
    this.mapSetCenter(center)
    this.setState({
      selectPoi: value,
      latitude: lat,
      longitude: lng,
      code: ad_info.adcode,
    })
  }

  render() {
    const { visible, record } = this.props
    const {
      name,
      account,
      official_person,
      contact_number,
      official_person_phone,
      club_address,
      poiList,
      province,
      city,
      area,
      locationArr,
      provinceIndex,
      cityIndex,
    } = this.state
    const bankInput1 = [
      {
        id: 1,
        title: '俱乐部名称',
        default: name,
        disabled: false,
        placeholder: '请输入俱乐部名称',
        left: '1rem',
        width: '50%',
        dispatch: (v) => this.setState({ name: v }),
      },
      {
        id: 2,
        title: '账号',
        default: account,
        disabled: false,
        placeholder: '请输入账号',
        left: '3.6rem',
        width: '50%',
        dispatch: (v) => this.setState({ account: v }),
      },
    ]
    const bankInput2 = [
      {
        id: 3,
        title: '负责人',
        default: official_person,
        disabled: false,
        placeholder: '请输入负责人名字',
        left: '2.7rem',
        width: '50%',
        dispatch: (v) => this.setState({ official_person: v }),
      },
      {
        id: 4,
        title: '联系电话',
        default: contact_number,
        disabled: false,
        placeholder: '请输入联系电话',
        left: '1.9rem',
        width: '50%',
        dispatch: (v) => this.setState({ contact_number: v }),
      },
      {
        id: 5,
        title: '负责人电话',
        default: official_person_phone,
        disabled: false,
        placeholder: '请输入负责人电话',
        left: '1rem',
        width: '50%',
        dispatch: (v) => this.setState({ official_person_phone: v }),
      },
      {
        id: 6,
        title: '地址',
        default: club_address,
        disabled: false,
        placeholder: '请输入俱乐部地址',
        left: '3.6rem',
        width: '50%',
        hasChildren: true,
        dispatch: (v) => this.setState({ club_address: v }),
      },
    ]
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    }
    return (
      <div>
        <Modal
          title="修改俱乐部信息"
          visible={visible}
          onOk={() =>
            this.props.handleOk({
              name: this.state.name,
              account: this.state.account,
              password: this.state.password,
              official_person: this.state.official_person,
              contact_number: this.state.contact_number,
              official_person_phone: this.state.official_person_phone,
              province: this.state.province,
              city: this.state.city,
              area: this.state.area,
              club_address: this.state.club_address,
              longitude: this.state.longitude,
              latitude: this.state.latitude,
              code: this.state.code,
            })
          }
          onCancel={this.props.handleCancel}
          width="1000px"
        >
          <div style={{ marginBottom: '2rem' }}>
            {bankInput1.map((item, idx) => (
              <InputGroup {...item} idx={idx} key={idx} />
            ))}
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">密码:</span>
              <Input
                size="large"
                type="password"
                style={{ width: '50%', marginLeft: '3.6rem' }}
                placeholder="请输入新密码,可以不填"
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </div>
            {/* {bankInput2.map((item, idx) => (
              <InputGroup {...item} idx={idx} key={idx}>
                {item.hasChildren && (
                  <Button
                    style={{ marginLeft: '10px' }}
                    type={'primary'}
                    onClick={() =>
                      this.addressLocation(
                        this.state.club_address || record.club_address
                      )
                    }
                  >
                    搜索地址
                  </Button>
                )}
              </InputGroup>
            ))} */}

            <div className="clubList_item">
              <span className="info-span">负责人:</span>
              <Input
                size="large"
                value={official_person}
                style={{ width: '50%', marginLeft: '2.7rem' }}
                placeholder="请输入负责人名字"
                disabled={false}
                onChange={(e) =>
                  this.setState({ official_person: e.target.value })
                }
              />
            </div>

            <div className="clubList_item">
              <span className="info-span">联系电话:</span>
              <Input
                size="large"
                value={contact_number}
                style={{ width: '50%', marginLeft: '1.9rem' }}
                placeholder="请输入联系电话"
                disabled={false}
                onChange={(e) =>
                  this.setState({ contact_number: e.target.value })
                }
              />
            </div>

            <div className="clubList_item">
              <span className="info-span">负责人电话:</span>
              <Input
                size="large"
                value={official_person_phone}
                style={{ width: '50%', marginLeft: '1rem' }}
                placeholder="请输入负责人电话"
                disabled={false}
                onChange={(e) =>
                  this.setState({ official_person_phone: e.target.value })
                }
              />
            </div>

            <div className="clubList_item">
              <span className="info-span">省:</span>
              <Select
                size="large"
                style={{ width: '50%', marginLeft: '4.5rem' }}
                value={province}
                onChange={(e, option) => {
                  this.setState({
                    province: e,
                    city: '',
                    area: '',
                    provinceIndex: option.key,
                    cityIndex: 0,
                  })
                }}
              >
                {locationArr.length > 0 &&
                  locationArr.map((item, index) => {
                    return (
                      <Option key={index} value={item.name}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </div>

            <div className="clubList_item">
              <span className="info-span">市:</span>
              <Select
                size="large"
                style={{ width: '50%', marginLeft: '4.5rem' }}
                value={city}
                onChange={(e, option) => {
                  this.setState({
                    city: e,
                    area: '',
                    cityIndex: option.key,
                  })
                }}
                disabled={!province}
              >
                {locationArr.length > 0 &&
                  locationArr[provinceIndex].children.map((item, index) => {
                    return (
                      <Option key={index} value={item.name}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </div>

            <div className="clubList_item">
              <span className="info-span">区:</span>
              <Select
                size="large"
                style={{ width: '50%', marginLeft: '4.5rem' }}
                value={area}
                onChange={(e, option) => {
                  this.setState({
                    area: e,
                  })
                }}
                disabled={!city}
              >
                {locationArr.length > 0 &&
                  locationArr[provinceIndex].children[cityIndex].children.map(
                    (item, index) => {
                      return (
                        <Option key={index} value={item.name}>
                          {item.name}
                        </Option>
                      )
                    }
                  )}
              </Select>
            </div>

            <div className="clubList_item">
              <span className="info-span">地址:</span>
              <Input
                size="large"
                value={club_address}
                style={{ width: '50%', marginLeft: '3.6rem' }}
                placeholder="请输入俱乐部地址"
                disabled={false}
                onChange={(e) =>
                  this.setState({ club_address: e.target.value })
                }
              />
              <Button
                style={{ marginLeft: '10px' }}
                type={'primary'}
                onClick={() =>
                  this.addressLocation(
                    `${this.state.province}${this.state.city}${this.state.area}${this.state.club_address}` ||
                      `${record.province}${record.city}${record.area}${record.club_address}`
                  )
                }
              >
                搜索地址
              </Button>
            </div>

            {/* <div className="write-addres-view">
              <p>
                注：手动输入地址时请包含城市名称，否则会影响解析效果；如：(广州市天河区...)
              </p>
            </div> */}
            <div className="location-tip-text">
              <p style={{ paddingLeft: '0.5rem' }}>定位:</p>
            </div>
            <div className="bottom-map-view">
              <div className="sup-map-view">
                {this.state.isFinish && (
                  <img className="marker-center-view" src={MarkerImg} alt="" />
                )}
                <div id={'mQmap'} className="map-view" />
              </div>
              <div className="location-list-view">
                {poiList.length > 0 && (
                  <Radio.Group
                    onChange={this.poiRadioEvent}
                    value={this.state.selectPoi}
                  >
                    {poiList.map((item, index) => {
                      return (
                        <Radio style={radioStyle} value={item.id} key={item.id}>
                          {item.title}
                        </Radio>
                      )
                    })}
                  </Radio.Group>
                )}
              </div>
            </div>
            <div className="write-map-view">
              <p>
                操作方法：用鼠标拖动地图，将中间点对准您想定位的地点，就可以精确定位
              </p>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/component/modal.js